import React, { useState, lazy, Suspense } from "react";
import { Dialog } from "@mui/material";
import { getVehicleModelsList } from "../../../services/vehicle";
import Constants from "../../../services/Constants";
import OTAPagination from "../../OTAPagination";
import { getVehicleModelsDataColumns } from "./VehicleModelsDataColumns";
import { CreateVehicleModelSkeleton } from "../../common/DialogSkeleton";

const EditVehicleModel = lazy(() => import("./EditVehicleModel").then(mod => ({ default: mod.EditVehicleModel })));
const DeleteVehicleModel = lazy(() => import("./DeleteVehicleModel").then(mod => ({ default: mod.DeleteVehicleModel })));

const VehicleModelsDataGrid = ({ onAddTrim, onViewTrims, ...props }) => {
  const [editModel, setEditModel] = useState(null);
  const [deleteModel, setDeleteModel] = useState(null);

  const columns = getVehicleModelsDataColumns({
    onEdit: setEditModel,
    onDelete: setDeleteModel,
    onAddTrim,
    onViewTrims,
  });

  return (
    <>
      <OTAPagination
        tableTitle="Available Vehicle Models"
        columns={columns}
        endpoint={Constants.LIST_VEHICLE_MODELS}
        endpointFn={getVehicleModelsList}
        queryName={"vehicleModelsList"}
        filterMode="server"
        sortByDefault={"createdAt"}
        getRowId={(row) => row.modelId}
        {...props}
      />

      {editModel && (
      <Dialog
          open
          onClose={() => EditVehicleModel(null)}
          maxWidth="sm"
          fullWidth
          scroll="paper"
          PaperProps={{
            sx: {
              width: "90%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
            },
          }}
        >
          <Suspense fallback={<CreateVehicleModelSkeleton />}>
            <EditVehicleModel
              model={editModel}
              toggleDialog={() => setEditModel(null)}
            />
          </Suspense>
        </Dialog>
      )}

      {deleteModel && (
        <Dialog
          open
          onClose={() => setDeleteModel(null)}
          PaperProps={{ sx: { width: "35%", maxWidth: "500px" } }}
        >
          <Suspense fallback={<CreateVehicleModelSkeleton />}>
            <DeleteVehicleModel
              model={deleteModel}
              toggleDialog={() => setDeleteModel(null)}
            />
          </Suspense>
        </Dialog>
      )}
    </>
  );
};

export default VehicleModelsDataGrid;